import React from 'react';
import { cn } from '@/lib/utils';
import { Numeric } from './numeric';

export interface MetricCardProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  value: string | number;
  subtitle?: string;
  icon?: React.ReactNode;
  change?: {
    value: string | number;
    isPositive: boolean;
  };
  loading?: boolean;
}

export const MetricCard = React.forwardRef<HTMLDivElement, MetricCardProps>(
  ({ className, title, value, subtitle, icon, change, loading = false, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('border-border bg-card rounded-lg border p-4 shadow-sm', className)}
        {...props}
      >
        {icon && <div className="text-primary mb-2">{icon}</div>}
        <Numeric className="text-foreground block text-3xl font-extrabold tracking-tight">
          {loading ? '...' : value}
        </Numeric>
        {change && (
          <Numeric
            className={cn(
              'mt-1 inline-block rounded-full px-2 py-0.5 text-xs font-semibold',
              change.isPositive ? 'bg-success/10 text-success' : 'bg-danger/10 text-danger',
            )}
          >
            {change.isPositive ? '+' : ''}
            {change.value}
          </Numeric>
        )}
        <div className="text-muted mt-1 text-sm">{title}</div>
        {subtitle && <Numeric className="text-muted block text-xs">{subtitle}</Numeric>}
      </div>
    );
  },
);
MetricCard.displayName = 'MetricCard';
